/**
 * Текст ошибки для человека — один источник на всю админку.
 *
 * Сервер теперь переводит все коды сам: каждый модуль регистрирует свой словарь
 * в ядре, и в ответе приходит готовое сообщение на языке запроса. До этого
 * админка держала собственные копии переводов для E01, E06 и E10 — два источника,
 * которые обязаны были разойтись при первой же правке формулировки.
 *
 * Код ошибки возвращается отдельно: его показывают мелким шрифтом под текстом,
 * чтобы было что назвать в обращении в поддержку.
 */
export interface ErrorText {
  readonly message: string;
  readonly code: string;
}

const FALLBACK = 'Не удалось выполнить запрос';

export function errorText(err: unknown, fallback: string = FALLBACK): ErrorText {
  const candidate = err as { message?: unknown; code?: unknown } | null;
  const code = typeof candidate?.code === 'string' ? candidate.code : 'E00.internal';
  const message =
    typeof candidate?.message === 'string' && candidate.message.trim() !== ''
      ? candidate.message
      : fallback;

  // Если сервер по какой-то причине отдал сам код вместо текста, показывать его
  // как сообщение бессмысленно — лучше честная общая формулировка плюс код.
  return { message: message === code ? fallback : message, code };
}
